import React from 'react';

import { PrimaryContextsReadyContextProvider } from './PrimaryContextsReadyContext';

const withPrimaryContextsReadyContext = (Component) => (props) => (
  <PrimaryContextsReadyContextProvider>
    <Component {...props} />
  </PrimaryContextsReadyContextProvider>
);

export {
  withPrimaryContextsReadyContext,
};
